import React, { useMemo } from "react";
import DOMPurify from "dompurify";
import { FaExpand } from "react-icons/fa";

import Reveal from "../../../components/ui/Reveal";

import ProjetAdaptiveImage from "./ProjetAdaptiveImage";

export default function ProjetDetail({ projet, onZoom }) {
  const sanitizedDescription = useMemo(() => {
    return DOMPurify.sanitize(projet?.descriptionRaw || "");
  }, [projet]);

  if (!projet) return null;

  return (
    <article id="projet-detail" className="scroll-mt-24">
      <Reveal>
        <ProjetAdaptiveImage
          src={projet.image}
          alt={projet.imageAlt}
          zoomable
          onClick={onZoom}
        />

        <div className="mt-3 flex justify-end">
          <button
            type="button"
            onClick={onZoom}
            className="inline-flex min-h-10 items-center justify-center gap-2 rounded-2xl bg-slate-950/80 px-4 text-sm font-bold text-white shadow-sm transition hover:bg-slate-950"
          >
            <FaExpand className="h-3.5 w-3.5" />
            Agrandir l’image
          </button>
        </div>
      </Reveal>

      <Reveal>
        <section className="mt-6 rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6">
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center rounded-full bg-[#1277B9] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-white">
              Grand projet
            </span>

            {projet.updatedLabel && (
              <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500 dark:bg-slate-900 dark:text-slate-300">
                Dernière mise à jour : {projet.updatedLabel}
              </span>
            )}
          </div>

          <h2 className="mt-4 text-2xl font-bold tracking-tight text-slate-950 dark:text-white md:text-3xl">
            {projet.title}
          </h2>

          <div className="mt-5">
            {sanitizedDescription ? (
              <div
                className="prose prose-sm max-w-none leading-relaxed text-slate-700 prose-headings:text-slate-950 prose-a:text-[#1277B9] prose-img:rounded-2xl dark:prose-invert dark:text-slate-200 sm:prose-base"
                dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
              />
            ) : (
              <p className="text-sm leading-7 text-slate-600 dark:text-slate-300">
                La description détaillée de ce projet sera prochainement
                disponible.
              </p>
            )}
          </div>
        </section>
      </Reveal>
    </article>
  );
}